import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DocumentoAllegato } from 'src/app/common/models/documento-allegato';
import { FORM_CONFIGURATION, UploadFormConfiguration } from './campi';

@Injectable({
  providedIn: 'root'
})
export class UploadDocumentUtilityService {
  
  private _primaryChanges = new BehaviorSubject<{id: string;value:boolean}>(null);
  primaryChanges = this._primaryChanges.asObservable();
  private _tipoProduttoreChanges = new BehaviorSubject<{id: string;value: 'INTERNO' | 'ESTERNO'}>(null);
  tipoProduttoreChanges = this._tipoProduttoreChanges.asObservable();
  private tipoProduttoreInitialized = false;

  constructor() { }

  setPrimary(value:{id: string;value:boolean}) {
    this._primaryChanges.next(value);
  }

  hasTipoProduttoreBeenInitialized(): boolean {
    return this.tipoProduttoreInitialized;
  }

  markTipoProduttoreInitialized() {
    this.tipoProduttoreInitialized = true;
  }

  resetTipoProduttoreInitialized() {
    this.tipoProduttoreInitialized = false;
  }

  setTipoProduttore(value: { id: string; value: 'INTERNO' | 'ESTERNO' }) {
    if (!this.tipoProduttoreInitialized) {
      this._tipoProduttoreChanges.next(value);
      this.tipoProduttoreInitialized = true; // blocca propagazione futura
    }
  }

  getConfigurationEdit(file: DocumentoAllegato, isProtocol?): UploadFormConfiguration {
    // console.log(file, 'FILE')
    let config = FORM_CONFIGURATION;
    // ARCHIVI
    if (
      file.contentType === 'application/zip' || // zip
      file.contentType === 'message/rfc822' || // eml
      file.contentType === 'application/vnd.ms-outlook' || // msg
      file.contentType === 'application/vnd.rar' || // rar
      file.contentType === 'application/x-rar' || // rar
      file.contentType === 'application/x-rar-compressed' || // rar
      file.contentType === 'application/mbox' || // mbox
      file.contentType === 'application/x-mbox' // mbox
    ) {
      return config.archive;
    }

    // FIRMA ASSENTE
    if(!file.metadatoFirmaDocumenti || file.metadatoFirmaDocumenti.length === 0) {
      return config.notSigned;
    }
    // FIRMA PRESENTE
    /** Controllo se vi è almeno un elemento che abbia esitoVerifica.id === "NON_VALIDA" */
    let hasNotValid = file.metadatoFirmaDocumenti.findIndex(el => el.esitoVerifica.id === "NON_VALIDA") > -1 
    if (hasNotValid) {
      // FIRMA NON VALIDA
      return !!file.numeroProtocollo
        ? config.signedNotValidProtocol
        : config.signedNotValid;
    } else if(!hasNotValid) {
      // FIRMA VALIDA
      return config.signed;
    }
  }

  getConfiguration(file: DocumentoAllegato, isProtocol): UploadFormConfiguration {
    let config = FORM_CONFIGURATION;
    // ARCHIVI
    if (
      file.contentType === 'application/zip' || // zip
      file.contentType === 'message/rfc822' || // eml
      file.contentType === 'application/vnd.ms-outlook' || // msg
      file.contentType === 'application/vnd.rar' || // rar
      file.contentType === 'application/x-rar' || // rar
      file.contentType === 'application/x-rar-compressed' || // rar
      file.contentType === 'application/mbox' || // mbox
      file.contentType === 'application/x-mbox' // mbox
    ) {
      return config.archive;
    }

    // FIRMA ASSENTE
    if (!file.signedData || !file.signedData.statoFirma) {
      return config.notSigned;
    }
    const statoFirma = file.signedData.statoFirma;
    switch (statoFirma) {
    case 'VALIDA':
      return config.signed;

    case 'ASSENTE':
    case 'NON_SUPPORTATO':
      return config.notSigned;

    default:
      // NON VALIDA
      return !!isProtocol
        ? config.signedNotValidProtocol
        : config.signedNotValid;
    }
  }
}